import React from 'react';
import PageTitle from './PageTitle';

interface HomeRouteProps {
  title?: string;
  children: React.ReactNode;
}

const HomeRoute: React.FC<HomeRouteProps> = ({ title, children }) => {
  return (
    <>
      <PageTitle title={title} />
      {children}
    </>
  );
};

export default HomeRoute;
